import * as React from 'react';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { TextFormGroup, NumberFormGroup, DatePickerFormGroup, MenuItemDto } from '../../uiComponents/input/FormGroups';
import { Konkurrence } from '../../models/Konkurrence';
import { Form, Row, Col, Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { LinkSecondaryButton } from '../../uiComponents/input/Buttons';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import FileInput, { RichTextFormGroup } from '../../uiComponents/input/FormGroups';
import { getBackendBaseUrl } from '../../infrastructure/BackendUrlResolver';
// import { Link } from 'react-router-dom';
import { Modal } from '../../uiComponents/layout/Modal';
import { RouteComponentProps } from 'react-router';
import { Opgavepakke } from '../../models/Opgavepakke';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import Autocomplete from '../../uiComponents/input/Autocomplete';
import { EditorState } from 'draft-js';
import { EksternBruger } from '../../models/EksternBruger';
import { Guid } from '../../infrastructure/Guid';

interface KonkurrenceEditProps extends RouteComponentProps<any> {
    isNew: boolean;
    konkurrence: Konkurrence;
    errorMessages: ValidationError[];
    opgavepakker: Opgavepakke[];
    eksterne: EksternBruger[];
    kommuner: any[];
    isSubmitting: boolean;
    onKonkurrenceChanged: (fieldName: string, value: any) => void;
    onBeskrivelseChanged: (editorState: EditorState) => void;
    beskrivelseEditorState: EditorState;
    onKonkurrenceSave: () => void;
    onKonkurrenceDelete: () => void;
    onFileUpload: (formData: FormData) => void;
}
class KonkurrenceEdit extends React.Component<KonkurrenceEditProps, any> {
    constructor(props: KonkurrenceEditProps) {
        super(props);
    }

    render() {
        const title = this.props.isNew ? 'Opret konkurrence' : 'Redigér konkurrence';
        const modal = !this.props.isNew ? (
            <Modal id='erDuSikker' alert={true} excludeCancel={true} text='Ønsker du at slette denne konkurrence?' >
                <Button buttonType='primary' onClick={this.props.onKonkurrenceDelete} dataDismiss='modal'>Slet</Button>
            </Modal>
        ) : undefined;
        let buttons = !this.props.isNew ? <Button buttonType='secondary' dataToggle='modal' dataTarget='#erDuSikker'>Slet konkurrence</Button> : undefined;

        let imagePlaceholder = 'Vælg billede';
        let imageButtons = null;

        if (this.props.konkurrence.billedId !== undefined && this.props.konkurrence.billedId !== null) {
            let imageUrl = getBackendBaseUrl() + '/api/image/' + this.props.konkurrence.billedId;
            imagePlaceholder = 'Billede uploadet';
            imageButtons = (
                <Row>
                    <Col md={12}>
                        <ButtonSection noBorder={false}>
                            <a href={imageUrl} target={'_blank'} className='btn btn-secondary'>Vis billede</a>
                            <Button className='spacer' buttonType='secondary' onClick={() => this.props.onKonkurrenceChanged('billedId', undefined)}>Fjern billede</Button>
                        </ButtonSection>
                    </Col>
                </Row>
            );
        }

        const alleKommuner: MenuItemDto[] = this.props.kommuner.map(k => new MenuItemDto(k.nummer, k.navn));

        const valgteKommuner: MenuItemDto[] = new Array();
        if (this.props.konkurrence.kommunenumre != null) {
            this.props.konkurrence.kommunenumre.forEach(kommunenummer => {
                const kommune = this.props.kommuner.find(x => x.nummer === kommunenummer);
                valgteKommuner.push(new MenuItemDto(kommune.nummer, kommune.navn));
            });
        }

        const opgavepakker = this.props.opgavepakker.map(o => new MenuItemDto(o.id, o.titel));
        const valgteOpgavepakker = this.props.konkurrence.opgavepakker            
            .map(o => new MenuItemDto(o.id, o.titel));

        const eksterne = this.props.eksterne.map(o => new MenuItemDto(o.id, o.email));
        const valgteEksterne = this.props.konkurrence.eksterne            
            .map(o => new MenuItemDto(o.id, o.email));

        const kanInviteresSomEksternCallback = (results: Array<string|Object>, props: any): boolean => {
            const regex = /\S+@\S+\.\S+/;
            if (!regex.test(props.text)) {
                return false;
            } 
            if (results.length > 0) {
                return false;
            }

            return true;
        };

        return (
            <div>
                <SectionGroup header={title} buttons={buttons}>
                    <Form onSubmit={this.props.onKonkurrenceSave}>
                        <Section>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <Autocomplete
                                        id='kommune-select-dropdown'
                                        errorMessages={this.props.errorMessages}
                                        label='Kommuner*'
                                        name='kommunenumre'
                                        placeholder='Vælg kommune'
                                        selected={valgteKommuner}
                                        onChange={this.props.onKonkurrenceChanged}
                                        data={alleKommuner}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3} mdOffset={3}>
                                    <DatePickerFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Afviklingsdato*'
                                        name='startdato'
                                        value={this.props.konkurrence.startdato}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />
                                </Col>
                                <Col md={3}>
                                    <DatePickerFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Synlig fra*'
                                        name='synligFraDato'
                                        value={this.props.konkurrence.synligFraDato}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />
                                </Col>
                            </Row>
                        </Section>
                        <Section>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <TextFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Titel*'
                                        name='titel'
                                        placeholder='Skriv titel'
                                        value={this.props.konkurrence.titel}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />                                    
                                    <RichTextFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Beskrivelse'
                                        name='beskrivelse'
                                        placeholder='En beskrivelse eller en note til deltagere'
                                        editorState={this.props.beskrivelseEditorState}
                                        onEditorChange={this.props.onBeskrivelseChanged}
                                    />
                                    <FileInput
                                        errorMessages={this.props.errorMessages}
                                        label='Konkurrencebillede'
                                        name='billedId'
                                        placeholder={imagePlaceholder}
                                        onFileUpload={this.props.onFileUpload}
                                    />
                                    <i>Det anbefalede billedeformat er 16:9</i>
                                </Col>
                            </Row>
                        </Section>
                        {imageButtons}
                        <Section>
                            <Row>
                                <Col md={3} mdOffset={3}>
                                    <TextFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Konkurrencested*'
                                        name='afviklingssted'
                                        placeholder='Skriv konkurrencested'
                                        value={this.props.konkurrence.afviklingssted}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />
                                </Col>
                                <Col md={3}>
                                    <TextFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Adresse*'
                                        name='adresse'
                                        placeholder='Skriv adresse'
                                        value={this.props.konkurrence.adresse}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={2} mdOffset={3}>
                                    <NumberFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Postnummer*'
                                        name='postnummer'
                                        placeholder='Skriv postnummer'
                                        value={this.props.konkurrence.postnummer}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='By*'
                                        name='bynavn'
                                        placeholder='Skriv bynavn'
                                        value={this.props.konkurrence.bynavn}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />
                                </Col>
                            </Row>
                        </Section>
                        <Section>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <Autocomplete
                                        id='opgavepakker-select-dropdown'
                                        errorMessages={this.props.errorMessages}
                                        label='Opgavepakker*'
                                        name='opgavePakkeIds'
                                        placeholder='Vælg opgavepakker'
                                        selected={valgteOpgavepakker}
                                        onChange={this.props.onKonkurrenceChanged}
                                        data={opgavepakker}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3} mdOffset={3}>
                                    <NumberFormGroup
                                        errorMessages={this.props.errorMessages}
                                        label='Max antal hold*'
                                        name='maxAntalHold'
                                        placeholder='Skriv max antal hold'
                                        value={this.props.konkurrence.maxAntalHold}
                                        onChange={this.props.onKonkurrenceChanged}
                                    />
                                </Col>
                            </Row>
                        </Section>
                        <Section>
                            <Row>
                                <Col md={6} mdOffset={3}>
                                    <Autocomplete
                                        id='eksterne-select-dropdown'
                                        errorMessages={this.props.errorMessages}
                                        label='Eksterne brugere (hvis den eksterne bruger ikke findes, skrives mailadressen på den nye eksterne bruger)'
                                        name='eksternIds'
                                        placeholder='Vælg evt. eksterne brugere'
                                        selected={valgteEksterne}
                                        onChange={this.props.onKonkurrenceChanged}
                                        data={eksterne}
                                        allowNew={kanInviteresSomEksternCallback}
                                        newSelectionPrefix={'Klik for at sende invitation til: '}
                                        noResultLabel={'Ingen resultater. Indtast en email for at invitere en ny ekstern bruger.'}
                                        transformData={(value: any[]) => value.map(y => {
                                            const key = y['key'] !== undefined ? y['key'] : Guid.newGuid();

                                            const obj = {
                                                'value': y['value'],
                                                'key': key
                                            };
            
                                            return obj;
                                        })}
                                        extraValidationField={'email'}
                                    />
                                </Col>
                            </Row>
                        </Section>

                        <ButtonSection noBorder={true}>
                            <LinkSecondaryButton className='spacer' url={'/konkurrencer'} text='Fortryd' />
                            <SubmitButton isSubmitting={this.props.isSubmitting}>Gem konkurrence</SubmitButton>
                        </ButtonSection>
                    </Form>
                </SectionGroup>
                {modal}
            </div>
        );
    }
}

export default KonkurrenceEdit;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceEdit.tsx